// extracted by mini-css-extract-plugin
module.exports = {"seeMoreButton":"ExpandableText_seeMoreButton__RjAB9 components_buttonNoStyle__1q5IH","icon":"ExpandableText_icon__tfIza"};